import { Divider, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import {
  spacing,
  typography,
  colors,
} from "../../../../../../../../../assets/styles/tokens";

interface KeywordsSearchItemsAdsInfoProps {
  adGroup: string;
  campaign: string;
}

const KeywordsSearchItemsAdsInfo = ({
  adGroup,
  campaign,
}: KeywordsSearchItemsAdsInfoProps) => {
  return (
    <>
      <Stack sx={{mt:spacing.Spacing.xs.$value}}>
        <Typography
          variant="body2"
          sx={{
            color: colors.GrayLightMode[700].$value,
            fontSize: typography.Size.Text.xs.$value,
            mb:spacing.Spacing.xxs.$value,
          }}
        >
          Ad Group
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: colors.GrayLightMode[900].$value,
            fontSize: typography.Size.Text.xs.$value,
            fontWeight: typography.Font_weight.Bold.$value,
          }}
        >
          {adGroup}
        </Typography>
        <Divider sx={{my:0.5}}/>
        <Typography
          variant="body2"
          sx={{
            color: colors.GrayLightMode[700].$value,
            fontSize: typography.Size.Text.xs.$value,
            mb:spacing.Spacing.xxs.$value,
          }}
        >
          Campaign
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: colors.GrayLightMode[900].$value,
            fontSize: typography.Size.Text.xs.$value,
            fontWeight: typography.Font_weight.Bold.$value,
          }}
        >
          {campaign}
        </Typography>
      </Stack>
    </>
  );
};

export default KeywordsSearchItemsAdsInfo;
